export enum TritonChart {
    READINESS = 'readiness',
    SCORE = 'score',
    INTENSITY = 'intensity',
    FOCUS = 'focus',
}
